export default "__VITE_ASSET__CT4ZVL1c__"